import "../styles/home.css"
import {Swiper, SwiperSlide} from "swiper/react";
import {A11y, EffectFade, Navigation, Pagination, Scrollbar, Autoplay} from "swiper/modules";
import {getIcon, smoothScrollToId} from "../utils/helper";
import {useEffect, useRef, useState} from "react";
import {gsap} from 'gsap';
import SectionTop from "../components/home/SectionTop";
import SectionAboutUs from "../components/home/SectionAboutus";
import SectionFood from "../components/home/SectionFood";
import SectionContactUs from "../components/home/SectionContactUs";
import SectionFindTable from "../components/home/SectionFindTable";
import SectionPartyEvent from "../components/home/SectionPartyEvent";

export const HomePage = () => {
    const swiperRef = useRef(null);
    const imageRefs = useRef([]);
    const [indexSlide, setIndexSlide] = useState();
    let effectStyle = {
        opacity: 1,
        x: 0,
        y: 0,
        ease: "power3.inOut",
        delay: 0.4,
        stagger: 0.2
    }
    useEffect(() => {
        gsap.to(".swiper > .swiper-button-next-custom", 1, effectStyle);
        gsap.to(".swiper > .swiper-button-prev-custom", 1, effectStyle);
        gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > *", 0.5, effectStyle);
    }, [])
    const slides = [
        {
            image: "assets/images/slides/hero-slider-1.jpeg", // Đường dẫn ảnh giữ nguyên
            subtitle: "Traditionell & Hygienisch", // Traditional & Hygienic
            heroTitle: "Aus Liebe zu köstlichem Essen", // For the love of delicious food
            heroText: "Kommen Sie mit Familie & genießen Sie die Freude an köstlichem Essen" // Come with family & enjoy the joy of delicious food (thay "mouthwatering" bằng "delicious" cho tự nhiên hơn)
            // Hoặc một lựa chọn khác cho heroText, nhấn mạnh hơn: "Kommen Sie mit Familie & erleben Sie wahre Gaumenfreuden" (Come with family & experience true culinary delights)
        },
        {
            image: "assets/images/slides/hero-slider-2.jpeg",
            subtitle: "Fantastisch & Köstlich", // amazing & delicious
            heroTitle: "Wo jeder Geschmack eine Geschichte erzählt", // Where every flavor tells a story
            heroText: "Kommen Sie mit Familie & genießen Sie die Freude an köstlichem Essen" // (Giống như trên)
            // Hoặc: "Kommen Sie mit Familie & erleben Sie wahre Gaumenfreuden"
        },
        {
            image: "assets/images/slides/hero-slider-3.jpeg",
            subtitle: "Ein herrliches Erlebnis", // a delightful experience (Sửa lỗi chính tả "experienc")
            heroTitle: "Aromen, inspiriert von den Jahreszeiten", // Flavors Inspired by the Seasons
            heroText: "Kommen Sie mit Familie & genießen Sie die Freude an köstlichem Essen" // (Giống như trên)
            // Hoặc: "Kommen Sie mit Familie & erleben Sie wahre Gaumenfreuden"
        },
    ]
    useEffect(() => {
        gsap.config({nullTargetWarn: false});
        const swiperInstance = swiperRef.current ? swiperRef.current.swiper : null;

        if (swiperInstance) {
            animateCurrentImage(imageRefs.current)
        }
        return () => {
            gsap.killTweensOf(imageRefs.current);
        };
    }, [indexSlide])

    const animateCurrentImage = (images) => {
        images.forEach((img, index) => {
            if (img) {
                gsap.to(img, {
                    scale: 1,
                    duration: 0.3,
                    ease: 'power2.out',
                });
            }
        });

        // Lấy tham chiếu đến ảnh của slide hiện tại
        const currentImage = images[indexSlide];
        // Kiểm tra xem currentImage có tồn tại không trước khi animate
        if (currentImage) {
            // Animate ảnh hiện tại
            gsap.to(currentImage, {
                scale: 1.2, // Zoom 1.2 lần
                duration: 5,
                ease: 'power2.out',
            });
        }

    };
    const handleOpenNewTab = () => {
        if(window){
            window.open('https://d-gastro24.de/order/hamirestaurant', '_blank', 'noopener,noreferrer');
        }
    };
    const handleOpenScroll = () => {
        smoothScrollToId('tisch-reservieren')
    }
    return <div className={"container-home"}>
        <Swiper
            ref={swiperRef}
            modules={[Navigation, Pagination, Scrollbar, A11y, EffectFade, Autoplay]}
            // spaceBetween={50}
            slidesPerView={1}
            autoplay={{
                delay: 6000,
            }}
            onSwiper={(swiper) => {
            }}
            onSlideChange={(index) => {
                let hidden = {
                    ...effectStyle,
                    x: 40,
                    opacity: 0,
                    stagger: 0,
                    delay: 0
                }
                setIndexSlide(index?.realIndex);
                gsap.to(".swiper-slide-next > .wrap-slider > .infor-slide > *", 0, hidden)
                gsap.to(".swiper-slide-prev > .wrap-slider > .infor-slide > *", 0, hidden)

                gsap.to(".swiper-slide-active > .wrap-slider > .infor-slide > *", 0.5, effectStyle)

            }}
            navigation={{
                nextEl: '.swiper-button-next-custom',
                prevEl: '.swiper-button-prev-custom'
            }}
            effect={"creative"}
            loop={true}
            pagination={{
                el: ".swiper-pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + ' tab-' + (index + 1) + '">' + "</span>";
                }
            }}
        >
            {slides.map(({image, subtitle, heroTitle, heroText}, index) => {
                return <SwiperSlide>
                    <div className="wrap-slider">
                        {/* Thay thế bằng nội dung thực tế của bạn */}
                        <img
                            className={`image-${index}`}
                            alt={`Slide ${index + 1}`}
                            ref={(el) => (imageRefs.current[index] = el)}
                            src={image}/>
                        <div className="slider-overlay"></div>
                        <div className="wrap-content infor-slide">
                            <p className="label-2 section-subtitle slider-reveal">{subtitle}</p>
                            <div className="icon-separator">
                                {getIcon("separator")}
                            </div>
                            <h1 className="display-1 hero-title slider-reveal">
                                {heroTitle}
                            </h1>

                            <p className="body-2 hero-text slider-reveal">
                                {heroText}
                            </p>
                          <div className="wrapBtn">
                              {/*<button onClick={handleOpenNewTab}  type="button" className={`btnSecondary btn`}>*/}
                              {/*    <span className={`text text1`}>Online bestellen</span>*/}
                              {/*    <span className={`text text2`} aria-hidden="true">Online bestellen</span>*/}
                              {/*</button>*/}
                              <button onClick={handleOpenScroll} type="button" className={`btnSecondary btn`}>
                                  <span className={`text text1`}>Tisch reservieren</span>
                                  <span className={`text text2`} aria-hidden="true">Tisch reservieren</span>
                              </button>
                          </div>
                        </div>
                        <a href="#" className="hero-btn has-after">
                            <img src="/assets/images/slides/hero-icon.png" width="48" height="48" alt="booking icon"/>

                                <span className="label-2 text-center span">Tisch reservieren</span>
                        </a>
                    </div>
                </SwiperSlide>
            })}


            {/* Thêm nhiều slide hơn nếu cần */}
            <div className="swiper-pagination"></div>


            <div className="swiper-button-prev-custom">
                <div className="icon-slide">
                    {getIcon("prev")}
                </div>
            </div>
            <div className="swiper-button-next-custom">
                <div className="icon-slide">
                    {getIcon("next")}
                </div>
            </div>
            <div className="swiper-pagination swiper-pagination-nested"></div>

        </Swiper>

        <SectionTop/>
        <SectionPartyEvent/>
        <SectionAboutUs/>
        <SectionFood/>
        <SectionContactUs/>
        <SectionFindTable/>
    </div>
}